module.exports = __webpack_public_path__ + "static/media/pic3.939c2e9d.jpg";